import ReactDOM from "react-dom";
import App from "./App"
import "./index.css"
import "./styles/terminal.css"
ReactDOM.render(<App/>, document.querySelector("#root"))